export interface ConfirmPendingTraining {
	level: number;
	trainingDate: Date;
	trainingId: number;
}

export class ConfirmPendingTraining implements ConfirmPendingTraining {
	constructor(data?: Partial<ConfirmPendingTraining>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}